import { gql } from '@apollo/client';

export const TAILS_LOOKUP = gql`
  query TailsLookup($term: String!) {
    tailsLookup(term: $term) {
      id
      tailNumber
    }
  }
`;

export const TAIL_LOOKUP = gql`
  query TailLookup($id: ID!) {
    tailLookup(id: $id) {
      id
      tailNumber
      operator {
        name
        avfuelAccounts {
          name
          accountNumber
        }
      }
    }
  }
`;